import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";
import { useAppDispatch } from "../../../../hooks/useRedux";
import driverDashboard_bg from "../../../../media/images/driverDashboard_bg.svg";
import { fetcherPost } from "../../../../services/fetcher";
import DashboardHeader from "./Header";
import MenuDashboard from "./MenuDashboard";
import SurveyModal from "./SurveyModal";

export default function DashboardPage() {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);

  const { trigger: getNobatSurveyTrigger } = useSWRMutation(
    [`/Nobat/GetNobatSurvey`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        if (data) setOpen(true);
      },
    }
  );

  useEffect(() => {
    setTimeout(() => {
      getNobatSurveyTrigger({});
    }, 500);
  }, []);
  return (
    <>
      <SurveyModal setOpen={setOpen} open={open} />
      <Box
        sx={{
          height: "100%",
          overflow: "auto",
          position: "relative",
          backgroundImage: `
         url(${driverDashboard_bg})
         `,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "#0D4884",
        }}
      >
        <Box
          sx={{
            paddingX: "8px",
            paddingTop: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            paddingBottom: "70px",
          }}
        >
          <DashboardHeader />
          <MenuDashboard />
        </Box>
        {/* <Box
          sx={{
            height: "160px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            paddingX: "8px",
            paddingBottom: "16px",
          }}
        >
          <SearchBox />
          <MainContent />
          <BannerBox />
        </Box> */}
        {/* <Box
          sx={{
            width: "100%",
            paddingX: "8px",
            paddingBottom: "16px",
          }}
        >
          <Activities />
        </Box> */}
      </Box>
    </>
  );
}
